import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SentEnvelopeStatusCounter } from '../model/sent-envelope-status-counter';
import { SentEnvelopeFilter } from '../model/sent-envelope-filter';
import { SentEnvelopeStatus } from 'src/app/enum/sent-envelope-status';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Envelope } from '../model/envelope';
import { MainEnvelopeToSend } from 'src/app/main-envelope/model/main-envelope.model';
import { EnvelopeFilter } from '../model/envelope-filter';
import { EnvelopeEdit } from '../model/envelope-edit';
import { EditEnvelopeToSend } from '../envelope-edit/model/edit-envelope.model';
import { EnvelopeDetailFilter } from '../model/envelope-detail-filter';
import { EnvelopeIds } from 'src/app/modules/signature/model/envelopeIds';
import { SignatoriesEnvelope } from 'src/app/modules/signature/model/signatoriesEnvelope';
import { FiltersEnvelope } from '../model/filters-envelope';

const CONTROLLER = 'envelope';
@Injectable({
  providedIn: 'root'
})
export class EnvelopeService {
  private envelopeDetailFilter: EnvelopeDetailFilter;

  constructor(private http: HttpClient) { }

  public insert(envelope: MainEnvelopeToSend): Observable<any> {
    return this.http.post(CONTROLLER + '/FullEnvelope', envelope);
  }

  public update(id: number, envelopeEdit: EnvelopeEdit): Observable<any> {
    return this.http.put(CONTROLLER + '/' + id, envelopeEdit);
  }

  public editFull(id: number, editEnvelope: EditEnvelopeToSend): Observable<any> {
    return this.http.post(CONTROLLER + '/' + id + '/EditFull', editEnvelope);
  }

  public getSentEnvelopeStatusCounter(filters: EnvelopeFilter): Observable<SentEnvelopeStatusCounter> {
    return this.http.post(CONTROLLER + '/total', filters)
      .pipe(
        map((response) => {
          const sentEnvelopeStatus = new SentEnvelopeStatusCounter();
          (response as Array<object>).forEach(element => {
            switch (element['status']) {
              case SentEnvelopeStatus.pending:
                sentEnvelopeStatus.pending = element['total'];
                break;
              case SentEnvelopeStatus.expired:
                sentEnvelopeStatus.expired = element['total'];
                break;
              case SentEnvelopeStatus.completed:
                sentEnvelopeStatus.completed = element['total'];
                break;
              case SentEnvelopeStatus.onApproval:
                sentEnvelopeStatus.onApproval = element['total'];
                break;
              case SentEnvelopeStatus.deleted:
                sentEnvelopeStatus.deleted = element['total'];
                break;
              case SentEnvelopeStatus.reproved:
                sentEnvelopeStatus.reproved = element['total'];
                break;
              case SentEnvelopeStatus.toFill:
                sentEnvelopeStatus.toFill = element['total'];
                break;
              case SentEnvelopeStatus.rejected:
                sentEnvelopeStatus.rejected = element['total'];
                break;
              default:
                break;
            }
          });
          return sentEnvelopeStatus;
        }),
        catchError(this.handleError)
      );
  }

  public filterElements(filterType: SentEnvelopeFilter): Observable<Array<Envelope>> {
    return this.http.post<Array<Envelope>>(CONTROLLER + '/GetAll', filterType)
      .pipe(
        map((response: Envelope[]) => response),
        catchError(this.handleError)
      );
  }

  public getEnvelopeDetail(id: number, obfuscateMail: boolean = true, obfuscateSsn: boolean = true, obfuscatePhone: boolean = true, isDeleted: boolean = false) {
    this.envelopeDetailFilter = new EnvelopeDetailFilter();
    this.envelopeDetailFilter.id = id;
    this.envelopeDetailFilter.obfuscateMail = obfuscateMail;
    this.envelopeDetailFilter.obfuscateSsn = obfuscateSsn;
    this.envelopeDetailFilter.obfuscatePhone = obfuscatePhone;
    this.envelopeDetailFilter.isDeleted = isDeleted;
    return this.get(this.envelopeDetailFilter);
  }

  public delete(id: any, reasonDelete: string): Observable<any> {
    return this.http.delete(CONTROLLER + '/' + id, { params: { reasonDelete } });
  }

  public archived(id: any, reasonArchived: string): Observable<any> {
    return this.http.patch(CONTROLLER.concat('/archived').concat('/').concat(id), { reasonArchived });
  }

  public initialValidation(accessToken: string) {
    return this.http.get(CONTROLLER.concat('/validateAccessKey/' + accessToken));
  }

  public signatoriesEnvelope(envelopeIds: EnvelopeIds): Observable<Array<SignatoriesEnvelope>> {
    return this.http.post(CONTROLLER + '/signatoriesEnvelope', envelopeIds)
      .pipe(
        map((response: any) => response.value),
        catchError(this.handleError)
      );;
  }

  public getFilters(): Observable<FiltersEnvelope> {
    return this.http.get<FiltersEnvelope>(CONTROLLER + '/getFilters')
      .pipe(
        map((response: FiltersEnvelope) => response),
        catchError(this.handleError)
      );
  }

  private handleError(errorResponse: Response) {
    console.log(errorResponse.statusText);
    return throwError(errorResponse || 'Server error');
  }

  private get(envelopeDetailFilter): Observable<Envelope> {
    return this.http.get<Envelope>(CONTROLLER, { params: envelopeDetailFilter })
      .pipe(
        map((response: Envelope) => response),
        catchError(this.handleError)
      );
  }
}
